import React, { useState, useEffect } from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from '../../utilities/ScrollService';
import Animations from '../../utilities/Animations';
import "./Resume.css";
import Atcoder from './at.jpg'

 
 
import Cficon from './cf.jpg';
import Leetcode from './lc.png';
import "./footer.css";

const Resume = (props) => {
  /* STATES */
  const [selectedBulletIndex, setSelectedBulletIndex] = useState(0);
  const [carousalOffsetStyle, setCarousalOffsetStyle] = useState({});
  let str="Deployed";

  let fadeInScreenHandler = (screen) => {
    if(screen.fadeInScreen !== props.id)
      return;

    Animations.animations.fadeInScreen(props.id);
  };
  const fadeInSubscription = ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  /* REUSABLE MINOR COMPONENTS */
  const ResumeHeading = (props) => {
    return (
      <div className="resume-heading">
        <div className="resume-main-heading">
          <div className="heading-bullet"></div>
          <span>{props.heading ? props.heading : ""}</span>
          {props.fromDate && props.toDate ? (
            <div className="heading-date">
              {props.fromDate + "-" + props.toDate}
            </div>
          ) : (
            <div></div>
          )}
        </div>
        <div className="resume-sub-heading">
          <span>{props.subHeading ? props.subHeading : ""}</span>
        </div>
        <div className="resume-heading-description">
          <span>{props.description ? props.description : ""}</span>
        </div>
      </div>
    );
  };
  // { label: "Work History", logoSrc: "work-history.svg" }

  /* STATIC RESUME DATA */
  const resumeBullets = [
    { label: "Education", logoSrc: "education.svg" },
    { label: "Programming Skills", logoSrc: "programming-skills.svg" },
    { label: "Projects", logoSrc: "projects.svg" },
    { label: "Work Experience", logoSrc: "work-history.svg" },
    {label :"Competitive Programming " ,logoSrc:"programming-skills.svg"},
    { label: "Achievements", logoSrc: "interests.svg" },
  ];

  const programmingSkillsDetails = [

    { skill: "JavaScript", ratingPercentage: 85 },
    { skill: "React JS", ratingPercentage: 85 },
    { skill: " BootStrap", ratingPercentage: 85 },
    { skill: " Tailwind CSS", ratingPercentage: 80 },
    { skill: "Typescript", ratingPercentage: 89 },
    { skill: "C/C++", ratingPercentage: 80 },
    { skill: "DSA", ratingPercentage: 80 },
    { skill: "HTML", ratingPercentage: 80 },
    { skill: "CSS", ratingPercentage: 80 },
  ];

  const projectsDetails = [
    {
      title: <a href="https://ashwanijhaeshoppingwebsite.netlify.app/">E-shopping Website </a>,
       link: { Deployed:" ", src: " " },
      description:
        " An e-shopping website that resembles Amazon. Built in react, with the help of Bootstrap and Firebase",
      subHeading:
      "Technologies Used: React.js, Bootstrap, Firebase"
    },
    {
      title: <a href="https://imagesearchapp-ashwani.vercel.app/">Image Search App</a>,
     link: { Deployed:"Deployed",src:" " },
      description:
        "An image search app that displays images on the website as per user input. It uses infinte scroll. It fetches data from Unsplash API",
      subheading:
      "Technologies Used: React, Bootstrap, Unsplash"
    },
    {
      title: <a href=" ">Portfolio Website</a>,
      link: {Deployed:"Deployed", src:" " },
      description:
        " My personal Portfolio website created in react. It showcases all my details.",
      subHeading:
        "Technologies Used:  React Js, Bootstrap, Epress Js",
    },
    
  ];

  const resumeDetails = [
    /* EDUCATION */
    <div className="resume-screen-container" key="education">
    

      <ResumeHeading
        heading={  <a href="https://www.iiitkottayam.ac.in/#!/home">Indian Institute Of Information Technology Kottayam</a>}
        subHeading={"BACHELOR OF TECHNOLOGY"}
        fromDate={"2020"}
        toDate={"present"}
      />
    
     
       
    </div>,
    
    <div
      className="resume-screen-container programming-skills-container"
      key="programming-skills"
    >
      {programmingSkillsDetails.map((skill, index) => (
        <div className="skill-parent" key={index}>
          <div className="heading-bullet"></div>
          <span>{skill.skill}</span>
          <div className="skill-percentage">
            <div
              style={{ width: skill.ratingPercentage + "%" }}
              className="active-percentage-bar"
            ></div>
          </div>
        </div>
      ))}
    </div>,
    /* PROJECTS */
    <div className="resume-screen-container" key="projects">
      {projectsDetails.map((projectsDetails, index) => (
        <ResumeHeading
          key={index}
          heading={projectsDetails.title}
          subHeading={projectsDetails.subHeading}
          description={projectsDetails.description}
          // fromDate={projectsDetails.link.Deployed}
          // toDate={projectsDetails.link.src}
       
          

        />
       
      ))}
         
    </div>,
     <div className="resume-screen-container" key="work-experience">
     <div className="experience-container">
      <br></br>
       <ResumeHeading
       
         heading={"Dispatch For You Corporation"}
         subHeading={"Software Developer Intern"}
         fromDate={"2023 March"}
         toDate={"Present"}
       />
       <div className="experience-description">
         <span className="resume-description-text">
         I have recently joined the Dispatch For You team , where I am currently working on MVP- Gravitii(gravitii.xyz).
I am improving gravitii homepage UI components. Additionally, I am working on the gravitii’s backend infrastructure .My main skills on this product involve React, Postgresql ,FastAPI, UI/UX Design. This project
involves working closely with our product team to bring innovative features to market, while ensuring that the
platform remains scalable and performant. I am constantly exploring new technologies and methodologies to
improve our development process and deliver value to our users.
         </span>
       </div>
       
     </div>
   </div>,
    /* Interests */
    <div className="resume-screen-container" key="interests">
      <ResumeHeading
        heading="Competitive Programming"
        description=" I am also good  in competitive programming. I enjoy finding solutions to challenging coding questions. Regularly Participates in coding contests on Codeforces, Atcoder, Leetcode. Check out my profiles here."
      />
      <div className="footer">
      <div className="socialMedia">
        <tr>
       
          
          <td>
           <a href="https://leetcode.com/Shreepatiha/">
           <img className="lc" src={Leetcode} />
            </a> 
          </td>
          <td>
            <a href="https://codeforces.com/profile/shreepatiha">
            <img className="lc" src={Cficon} />
            </a>
           
          </td>
          <td>
           <a href="https://atcoder.jp/users/shreepatiha">
           <img className="lc" src={Atcoder} />
            </a> 
          </td>
        </tr>
         
       
     </div>
     
    
    </div>
    </div>,
     <div className="resume-screen-container1" key="interests">
       <ResumeHeading
       heading="Open source Contribution in Vulnerablilty/Bug Submission"
       description="Submitted several Bugs on bugcrowd and Hackerone. Featured in Hall of Fame in few companies."
       
     />
     <div className="hypr">
     <a href="https://bugcrowd.com/exim-vdp/hall-of-fame"><br></br>check here(shreepatiha)</a>
     </div>
     
     <br></br>
     <br></br>
      <ResumeHeading
       heading="IIITK Coding Club"
       description="Started IIITK Coding club along wih 5 other students .Also contributed to Problem setting for Juniors Coding Contest"
     />
     <br></br>

     <ResumeHeading
       heading=<a href="https://codeforces.com/profile/shreepatiha">Very Close to Pupil On Codeforces</a>
       description=" click above to check the profile"
     />
     
          
   
   
   </div>
     
    ,
  ];

  const handleCarousal = (index) => {
    let offsetHeight = 360;

    let newCarousalOffset = {
      style: { transform: "translateY(" + index * offsetHeight * -1 + "px)" },
    };

    setCarousalOffsetStyle(newCarousalOffset);
    setSelectedBulletIndex(index);
  };

  const getBullets = () => {
    return resumeBullets.map((bullet, index) => (
      <div
        onClick={() => handleCarousal(index)}
        className={
          index === selectedBulletIndex ? "bullet selected-bullet" : "bullet"
        }
        key={index}
      >
        <img
          className="bullet-logo"
          src={require(`../../assets/Resume/${bullet.logoSrc}`)}
          alt="B"
        />
        <span className="bullet-label">{bullet.label}</span>
      </div>
    ));
  };

  const getResumeScreens = () => {
    return (
      <div
        style={carousalOffsetStyle.style}
        className="resume-details-carousal"
      >
        {resumeDetails.map((ResumeDetail) => ResumeDetail)}
      </div>
    );
  };

  useEffect(() => {
    return () => {
        /* UNSUBSCRIBE THE SUBSCRIPTIONS */
        fadeInSubscription.unsubscribe();
    }
  }, [fadeInSubscription]);

  return (
    <div
      className="resume-container screen-container fade-in"
      id={props.id || ""}
    >
      <div className="resume-content">
        <ScreenHeading title={"Resume"} subHeading={"My formal Bio Details"} />
        <div className="resume-card">
          <div className="resume-bullets">
            <div className="bullet-container">
              <div className="bullet-icons"></div>
              <div className="bullets">{getBullets()}</div>
            </div>
          </div>

          <div className="resume-bullet-details">{getResumeScreens()}</div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
